"use strict";

// Хром создает span с фонтсайзом от родителей при создании списков
// https://code.google.com/p/chromium/issues/detail?id=149901#c2
// if(this.utils.browser('webkit')){
//  this.$editor.find('span[style^=font-size]').removeAttr('style');
// }
(function () {
    var htmlCollapser = {
        elements: {},
        mainElement: {},
        findElements: function () { //нигде не используется

        },
        collapse: function (node) {
            var elements = node.find('span[style^=font-size]'),
                element = {};
            if (elements.length) {
                for (var i = 0; i < elements.length; i++) {
                    element = $(elements[i]);
                    this.setAsRoot(element);
                }
            }
        },
        setAsRoot: function (node) {
            var parent = node.parent(),
                ctext = node.text(),
                ptext = parent.text(),
                tmpStyle = '',
                dtmpStyle = '';
            if (!parent.is('span')) {
                return;
            }
            if (ctext == ptext) {
                tmpStyle = parent.attr('style');
                dtmpStyle = parent.attr('data-redactor-style');
                parent.attr({
                    'style': node.attr('style'),
                    'data-redactor-style': node.attr('data-redactor-style')
                });
                node.attr({
                    'style': tmpStyle,
                    'data-redactor-style': dtmpStyle
                });
            } else {
                return;
            }
            this.setAsRoot(parent);
        },
    };
    $(document).on(Fotobook.events.REDACTOR_CHANGE, ".redactor-editor", function () {
        htmlCollapser.collapse($(this));
    });
})();